import React from 'react';
import { Paper } from '@material-ui/core';

const Notice = (props) => {
    return(
        <Paper style={{
            padding: '10px',
        }}>
            <h4 style={{color: 'red'}}>Notice</h4>
            <br/>
            <p>ජයන්ති විද්‍යාලීය ශිෂ්‍ය/ ශිෂ්‍යාවන් වෙත,</p>
            <p>අප විද්‍යාලය මගින් වෙබ් අඩවියක් නිර්මාණය කර, ලැබී ඇති නිවාඩු කාලය තුල තමන්ට අහිමිවී ගිය ඉගෙනුම් කාලය සදහා පැවරුම් ලබාදීම සිදුකර ඇත. ගුරුවරු තමන්ගේ කාලය, ශ්‍රමය, මුදල් වැය කර මේ සිදු කරනු ලබන්නේ විශාල මෙහෙවරකි. එම නිසා පංති අනුව ලබා දී ඇති පැවරුම් සියල්ලක්ම සිදුකිරීම ඔබගේ යුතුකමකි. නිවාඩුව අවසන්වී පාසලට පැමිණෙන විට ලබාදුන් පැවරුම් සියල්ලම ගුරුවරු විසින් පරික්ෂා කරනවා ඇත. දෙමව්පියන්ගේ වගකීම වන්නේද මෙය නිවාඩු කාලයක් නොව ස්වයං අධ්‍යයනයක් කළ යුතු කාලයක් ලෙස සලකා එම පැවරුම් සිදුකිරීමට දරුවන්ට උපදෙස් ලබා දීමය. මෙම වෙබ් අඩවියේ Link එක අනෙකුත් ශිෂ්‍ය/ ශිෂ්‍යාවන්ට ලබා දීමට කටයුතු කරන්න. ගුරුවරු ඹබගේ සහයට සිටී. ස්තූතියි.</p>
            <p> මෙයට නියෝජ්‍ය විදුහල්පති.</p>
        </Paper>
    );
};

export default Notice;